import { renderTemplate } from './utilities';
import template from '../templates/global-menu-item.tpl.html';

export default class GlobalMenuItem {

  constructor({ url, icon, title, description, legacyName = null, legacyUrl = null, enabled = false, selected = false }) {
    Object.assign(this, { url, icon, title, description, legacyName, legacyUrl, enabled, selected });
    this._opensInNewTab = false;
  }

  render() {
    this.element = renderTemplate(template, this);
    return this.element;
  }

  get classNames() {
    let classNames = [];

    if (this.selected) {
      classNames.push('active');
    }

    if (!this.enabled && !this.selected) {
      classNames.push('disabled');
    }

    return classNames.join(' ');
  }

  get disabledClass() {
    let classNames = [];

    if (!this.enabled && !this.selected) {
      classNames.push('disabled');
    }

    return classNames.join(' ');
  }

  get opensInNewTab() {
    return !this.selected && this._opensInNewTab;
  }

  set opensInNewTab(newValue) {
    this._opensInNewTab = newValue;
  }

}



// WEBPACK FOOTER //
// ./src/scripts/global-menu-item.js